{
  "schemaVersion": "candidate-theme-registry-v1",
  "themes": [
    {
      "key": "cinema",
      "sourceName": "retro-cinema-night.md",
      "outputName": "retro-cinema-night.candidate.v1.json",
      "catalogRevision": "catalog.retro-cinema.candidate-6",
      "theme": {
        "themeId": "theme.retro-cinema-night",
        "themeRevision": "rev.candidate-6",
        "compatibleRulesVersion": "rules-v0.3",
        "compatibleDealVersion": "deal-v1",
        "compatibleMatcherVersion": "matcher-v1",
        "supportedPlayerCounts": [
          3,
          4,
          5
        ],
        "candidateStatus": {
          "stage": "MARKDOWN_SOURCE_CANDIDATE",
          "humanPlaytested": false,
          "approvedForProduction": false,
          "notice": {
            "zh": "候选内容，尚未经过真人桌测，不得视为已平衡或可正式发布。",
            "en": "__TODO_TRANSLATION__"
          }
        },
        "title": {
          "zh": "电影院",
          "en": "__TODO_TRANSLATION__"
        },
        "scenario": {
          "zh": "今晚，你们相约一座刚重新开放的老电影院。",
          "en": "__TODO_TRANSLATION__"
        },
        "icebreakers": [
          {
            "icebreakerId": "retro-cinema.icebreaker-1",
            "zh": "你喜欢看怎样的影片呢？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "retro-cinema.icebreaker-2",
            "zh": "你去过最豪华的电影院是怎样的？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "retro-cinema.icebreaker-3",
            "zh": "你从小到大对电影的口味发生了怎样的变化？",
            "en": "__TODO_TRANSLATION__"
          }
        ],
        "cards": {
          "retro-cinema.a.i1": {
            "cardId": "retro-cinema.a.i1",
            "displayText": "迟到",
            "matchForms": [
              {
                "text": "迟到",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "迟到",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.i2": {
            "cardId": "retro-cinema.a.i2",
            "displayText": "反派",
            "matchForms": [
              {
                "text": "反派",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "反派",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.i3": {
            "cardId": "retro-cinema.a.i3",
            "displayText": "吻",
            "matchForms": [
              {
                "text": "吻",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "吻",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.i4": {
            "cardId": "retro-cinema.a.i4",
            "displayText": "营销",
            "matchForms": [
              {
                "text": "营销",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "营销",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.q1": {
            "cardId": "retro-cinema.a.q1",
            "displayText": "约会",
            "matchForms": [
              {
                "text": "约会",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "约会",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.q2": {
            "cardId": "retro-cinema.a.q2",
            "displayText": "素质",
            "matchForms": [
              {
                "text": "素质",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "素质",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.q3": {
            "cardId": "retro-cinema.a.q3",
            "displayText": "空调",
            "matchForms": [
              {
                "text": "空调",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "空调",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.q4": {
            "cardId": "retro-cinema.a.q4",
            "displayText": "天堂",
            "matchForms": [
              {
                "text": "天堂",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "天堂",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.a.q5": {
            "cardId": "retro-cinema.a.q5",
            "displayText": "洛杉矶",
            "matchForms": [
              {
                "text": "洛杉矶",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "洛杉矶",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.i1": {
            "cardId": "retro-cinema.b.i1",
            "displayText": "好看",
            "matchForms": [
              {
                "text": "好看",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "好看",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.i2": {
            "cardId": "retro-cinema.b.i2",
            "displayText": "厕所",
            "matchForms": [
              {
                "text": "厕所",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "厕所",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.i3": {
            "cardId": "retro-cinema.b.i3",
            "displayText": "安静",
            "matchForms": [
              {
                "text": "安静",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "安静",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.i4": {
            "cardId": "retro-cinema.b.i4",
            "displayText": "幻觉",
            "matchForms": [
              {
                "text": "幻觉",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "幻觉",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.q1": {
            "cardId": "retro-cinema.b.q1",
            "displayText": "无聊",
            "matchForms": [
              {
                "text": "无聊",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "无聊",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.q2": {
            "cardId": "retro-cinema.b.q2",
            "displayText": "睡着",
            "matchForms": [
              {
                "text": "睡着",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "睡着",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.q3": {
            "cardId": "retro-cinema.b.q3",
            "displayText": "排队",
            "matchForms": [
              {
                "text": "排队",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "排队",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.q4": {
            "cardId": "retro-cinema.b.q4",
            "displayText": "饮料",
            "matchForms": [
              {
                "text": "饮料",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "饮料",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.b.q5": {
            "cardId": "retro-cinema.b.q5",
            "displayText": "真实",
            "matchForms": [
              {
                "text": "真实",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "真实",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.i1": {
            "cardId": "retro-cinema.c.i1",
            "displayText": "预告",
            "matchForms": [
              {
                "text": "预告",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "预告",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.i2": {
            "cardId": "retro-cinema.c.i2",
            "displayText": "海报",
            "matchForms": [
              {
                "text": "海报",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "海报",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.i3": {
            "cardId": "retro-cinema.c.i3",
            "displayText": "旁白",
            "matchForms": [
              {
                "text": "旁白",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "旁白",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.i4": {
            "cardId": "retro-cinema.c.i4",
            "displayText": "狗",
            "matchForms": [
              {
                "text": "狗",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "狗",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.q1": {
            "cardId": "retro-cinema.c.q1",
            "displayText": "红色",
            "matchForms": [
              {
                "text": "红色",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "红色",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.q2": {
            "cardId": "retro-cinema.c.q2",
            "displayText": "感动",
            "matchForms": [
              {
                "text": "感动",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "感动",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.q3": {
            "cardId": "retro-cinema.c.q3",
            "displayText": "演员",
            "matchForms": [
              {
                "text": "演员",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "演员",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.q4": {
            "cardId": "retro-cinema.c.q4",
            "displayText": "散场",
            "matchForms": [
              {
                "text": "散场",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "散场",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.c.q5": {
            "cardId": "retro-cinema.c.q5",
            "displayText": "胶片",
            "matchForms": [
              {
                "text": "胶片",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "胶片",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.i1": {
            "cardId": "retro-cinema.d.i1",
            "displayText": "老实",
            "matchForms": [
              {
                "text": "老实",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "老实",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.i2": {
            "cardId": "retro-cinema.d.i2",
            "displayText": "银幕",
            "matchForms": [
              {
                "text": "银幕",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "银幕",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.i3": {
            "cardId": "retro-cinema.d.i3",
            "displayText": "手机",
            "matchForms": [
              {
                "text": "手机",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "手机",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.i4": {
            "cardId": "retro-cinema.d.i4",
            "displayText": "打架",
            "matchForms": [
              {
                "text": "打架",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "打架",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.q1": {
            "cardId": "retro-cinema.d.q1",
            "displayText": "喜剧",
            "matchForms": [
              {
                "text": "喜剧",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "喜剧",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.q2": {
            "cardId": "retro-cinema.d.q2",
            "displayText": "特效",
            "matchForms": [
              {
                "text": "特效",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "特效",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.q3": {
            "cardId": "retro-cinema.d.q3",
            "displayText": "交通",
            "matchForms": [
              {
                "text": "交通",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "交通",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.q4": {
            "cardId": "retro-cinema.d.q4",
            "displayText": "尺度",
            "matchForms": [
              {
                "text": "尺度",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "尺度",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.d.q5": {
            "cardId": "retro-cinema.d.q5",
            "displayText": "行业",
            "matchForms": [
              {
                "text": "行业",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "行业",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.i1": {
            "cardId": "retro-cinema.e.i1",
            "displayText": "角色",
            "matchForms": [
              {
                "text": "角色",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "角色",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.i2": {
            "cardId": "retro-cinema.e.i2",
            "displayText": "童年",
            "matchForms": [
              {
                "text": "童年",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "童年",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.i3": {
            "cardId": "retro-cinema.e.i3",
            "displayText": "垃圾",
            "matchForms": [
              {
                "text": "垃圾",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "垃圾",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.i4": {
            "cardId": "retro-cinema.e.i4",
            "displayText": "家长",
            "matchForms": [
              {
                "text": "家长",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "家长",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.q1": {
            "cardId": "retro-cinema.e.q1",
            "displayText": "放映",
            "matchForms": [
              {
                "text": "放映",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "放映",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.q2": {
            "cardId": "retro-cinema.e.q2",
            "displayText": "感情",
            "matchForms": [
              {
                "text": "感情",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "感情",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.q3": {
            "cardId": "retro-cinema.e.q3",
            "displayText": "爆米花",
            "matchForms": [
              {
                "text": "爆米花",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "爆米花",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.q4": {
            "cardId": "retro-cinema.e.q4",
            "displayText": "警察",
            "matchForms": [
              {
                "text": "警察",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "警察",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.e.q5": {
            "cardId": "retro-cinema.e.q5",
            "displayText": "座位",
            "matchForms": [
              {
                "text": "座位",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "座位",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.r.1": {
            "cardId": "retro-cinema.r.1",
            "displayText": "躺下",
            "matchForms": [
              {
                "text": "躺下",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "躺下",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.r.2": {
            "cardId": "retro-cinema.r.2",
            "displayText": "悬念",
            "matchForms": [
              {
                "text": "悬念",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "悬念",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.r.3": {
            "cardId": "retro-cinema.r.3",
            "displayText": "大厅",
            "matchForms": [
              {
                "text": "大厅",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "大厅",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.r.4": {
            "cardId": "retro-cinema.r.4",
            "displayText": "枪战",
            "matchForms": [
              {
                "text": "枪战",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "枪战",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "retro-cinema.r.5": {
            "cardId": "retro-cinema.r.5",
            "displayText": "票房",
            "matchForms": [
              {
                "text": "票房",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "票房",
              "en": "__TODO_TRANSLATION__"
            }
          }
        },
        "packets": [
          {
            "packetId": "retro-cinema.packet-a",
            "initial": [
              "retro-cinema.a.i1",
              "retro-cinema.a.i2",
              "retro-cinema.a.i3",
              "retro-cinema.a.i4"
            ],
            "penalty": [
              "retro-cinema.a.q1",
              "retro-cinema.a.q2",
              "retro-cinema.a.q3",
              "retro-cinema.a.q4",
              "retro-cinema.a.q5"
            ]
          },
          {
            "packetId": "retro-cinema.packet-b",
            "initial": [
              "retro-cinema.b.i1",
              "retro-cinema.b.i2",
              "retro-cinema.b.i3",
              "retro-cinema.b.i4"
            ],
            "penalty": [
              "retro-cinema.b.q1",
              "retro-cinema.b.q2",
              "retro-cinema.b.q3",
              "retro-cinema.b.q4",
              "retro-cinema.b.q5"
            ]
          },
          {
            "packetId": "retro-cinema.packet-c",
            "initial": [
              "retro-cinema.c.i1",
              "retro-cinema.c.i2",
              "retro-cinema.c.i3",
              "retro-cinema.c.i4"
            ],
            "penalty": [
              "retro-cinema.c.q1",
              "retro-cinema.c.q2",
              "retro-cinema.c.q3",
              "retro-cinema.c.q4",
              "retro-cinema.c.q5"
            ]
          },
          {
            "packetId": "retro-cinema.packet-d",
            "initial": [
              "retro-cinema.d.i1",
              "retro-cinema.d.i2",
              "retro-cinema.d.i3",
              "retro-cinema.d.i4"
            ],
            "penalty": [
              "retro-cinema.d.q1",
              "retro-cinema.d.q2",
              "retro-cinema.d.q3",
              "retro-cinema.d.q4",
              "retro-cinema.d.q5"
            ]
          },
          {
            "packetId": "retro-cinema.packet-e",
            "initial": [
              "retro-cinema.e.i1",
              "retro-cinema.e.i2",
              "retro-cinema.e.i3",
              "retro-cinema.e.i4"
            ],
            "penalty": [
              "retro-cinema.e.q1",
              "retro-cinema.e.q2",
              "retro-cinema.e.q3",
              "retro-cinema.e.q4",
              "retro-cinema.e.q5"
            ]
          }
        ],
        "reserves": [
          "retro-cinema.r.1",
          "retro-cinema.r.2",
          "retro-cinema.r.3",
          "retro-cinema.r.4",
          "retro-cinema.r.5"
        ],
        "allowedLineups": {
          "3": [
            {
              "lineupId": "retro-cinema.lineup-3-ace",
              "packetIds": [
                "retro-cinema.packet-a",
                "retro-cinema.packet-c",
                "retro-cinema.packet-e"
              ]
            }
          ],
          "4": [
            {
              "lineupId": "retro-cinema.lineup-4-abde",
              "packetIds": [
                "retro-cinema.packet-a",
                "retro-cinema.packet-b",
                "retro-cinema.packet-d",
                "retro-cinema.packet-e"
              ]
            }
          ],
          "5": [
            {
              "lineupId": "retro-cinema.lineup-5-abcde",
              "packetIds": [
                "retro-cinema.packet-a",
                "retro-cinema.packet-b",
                "retro-cinema.packet-c",
                "retro-cinema.packet-d",
                "retro-cinema.packet-e"
              ]
            }
          ]
        }
      }
    },
    {
      "key": "outdoor",
      "sourceName": "outdoor-sports.md",
      "outputName": "outdoor-sports.candidate.v1.json",
      "catalogRevision": "catalog.outdoor-sports.candidate-4",
      "theme": {
        "themeId": "theme.outdoor-sports-day",
        "themeRevision": "rev.candidate-4",
        "compatibleRulesVersion": "rules-v0.3",
        "compatibleDealVersion": "deal-v1",
        "compatibleMatcherVersion": "matcher-v1",
        "supportedPlayerCounts": [
          3,
          4,
          5
        ],
        "candidateStatus": {
          "stage": "MARKDOWN_SOURCE_CANDIDATE",
          "humanPlaytested": false,
          "approvedForProduction": false,
          "notice": {
            "zh": "候选内容，尚未经过真人桌测，不得视为已平衡或可正式发布。",
            "en": "__TODO_TRANSLATION__"
          }
        },
        "title": {
          "zh": "户外运动",
          "en": "__TODO_TRANSLATION__"
        },
        "scenario": {
          "zh": "周末了，要不要出门玩呢？",
          "en": "__TODO_TRANSLATION__"
        },
        "icebreakers": [
          {
            "icebreakerId": "outdoor-sports.icebreaker-1",
            "zh": "你喜欢什么运动？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "outdoor-sports.icebreaker-2",
            "zh": "你绝对不会参与的运动是什么？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "outdoor-sports.icebreaker-3",
            "zh": "如果你是室内人，有什么东西会让你出门运动呢？",
            "en": "__TODO_TRANSLATION__"
          }
        ],
        "cards": {
          "outdoor-sports.a.i1": {
            "cardId": "outdoor-sports.a.i1",
            "displayText": "下雨",
            "matchForms": [
              {
                "text": "下雨",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "下雨",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.i2": {
            "cardId": "outdoor-sports.a.i2",
            "displayText": "受伤",
            "matchForms": [
              {
                "text": "受伤",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "受伤",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.i3": {
            "cardId": "outdoor-sports.a.i3",
            "displayText": "朋友",
            "matchForms": [
              {
                "text": "朋友",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "朋友",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.i4": {
            "cardId": "outdoor-sports.a.i4",
            "displayText": "鞋带",
            "matchForms": [
              {
                "text": "鞋带",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "鞋带",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.q1": {
            "cardId": "outdoor-sports.a.q1",
            "displayText": "综艺",
            "matchForms": [
              {
                "text": "综艺",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "综艺",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.q2": {
            "cardId": "outdoor-sports.a.q2",
            "displayText": "天气",
            "matchForms": [
              {
                "text": "天气",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "天气",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.q3": {
            "cardId": "outdoor-sports.a.q3",
            "displayText": "开车",
            "matchForms": [
              {
                "text": "开车",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "开车",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.q4": {
            "cardId": "outdoor-sports.a.q4",
            "displayText": "躺平",
            "matchForms": [
              {
                "text": "躺平",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "躺平",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.a.q5": {
            "cardId": "outdoor-sports.a.q5",
            "displayText": "速度",
            "matchForms": [
              {
                "text": "速度",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "速度",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.i1": {
            "cardId": "outdoor-sports.b.i1",
            "displayText": "休息",
            "matchForms": [
              {
                "text": "休息",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "休息",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.i2": {
            "cardId": "outdoor-sports.b.i2",
            "displayText": "胜负",
            "matchForms": [
              {
                "text": "胜负",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "胜负",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.i3": {
            "cardId": "outdoor-sports.b.i3",
            "displayText": "神经",
            "matchForms": [
              {
                "text": "神经",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "神经",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.i4": {
            "cardId": "outdoor-sports.b.i4",
            "displayText": "信号",
            "matchForms": [
              {
                "text": "信号",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "信号",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.q1": {
            "cardId": "outdoor-sports.b.q1",
            "displayText": "力量",
            "matchForms": [
              {
                "text": "力量",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "力量",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.q2": {
            "cardId": "outdoor-sports.b.q2",
            "displayText": "吃饭",
            "matchForms": [
              {
                "text": "吃饭",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "吃饭",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.q3": {
            "cardId": "outdoor-sports.b.q3",
            "displayText": "拍照",
            "matchForms": [
              {
                "text": "拍照",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "拍照",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.q4": {
            "cardId": "outdoor-sports.b.q4",
            "displayText": "山顶",
            "matchForms": [
              {
                "text": "山顶",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "山顶",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.b.q5": {
            "cardId": "outdoor-sports.b.q5",
            "displayText": "中医",
            "matchForms": [
              {
                "text": "中医",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "中医",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.i1": {
            "cardId": "outdoor-sports.c.i1",
            "displayText": "出汗",
            "matchForms": [
              {
                "text": "出汗",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "出汗",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.i2": {
            "cardId": "outdoor-sports.c.i2",
            "displayText": "呼吸",
            "matchForms": [
              {
                "text": "呼吸",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "呼吸",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.i3": {
            "cardId": "outdoor-sports.c.i3",
            "displayText": "生态",
            "matchForms": [
              {
                "text": "生态",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "生态",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.i4": {
            "cardId": "outdoor-sports.c.i4",
            "displayText": "海拔",
            "matchForms": [
              {
                "text": "海拔",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "海拔",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.q1": {
            "cardId": "outdoor-sports.c.q1",
            "displayText": "驴友",
            "matchForms": [
              {
                "text": "驴友",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "驴友",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.q2": {
            "cardId": "outdoor-sports.c.q2",
            "displayText": "登顶",
            "matchForms": [
              {
                "text": "登顶",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "登顶",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.q3": {
            "cardId": "outdoor-sports.c.q3",
            "displayText": "喝水",
            "matchForms": [
              {
                "text": "喝水",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "喝水",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.q4": {
            "cardId": "outdoor-sports.c.q4",
            "displayText": "生火",
            "matchForms": [
              {
                "text": "生火",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "生火",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.c.q5": {
            "cardId": "outdoor-sports.c.q5",
            "displayText": "导航",
            "matchForms": [
              {
                "text": "导航",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "导航",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.i1": {
            "cardId": "outdoor-sports.d.i1",
            "displayText": "累",
            "matchForms": [
              {
                "text": "累",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "累",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.i2": {
            "cardId": "outdoor-sports.d.i2",
            "displayText": "早起",
            "matchForms": [
              {
                "text": "早起",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "早起",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.i3": {
            "cardId": "outdoor-sports.d.i3",
            "displayText": "方向",
            "matchForms": [
              {
                "text": "方向",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "方向",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.i4": {
            "cardId": "outdoor-sports.d.i4",
            "displayText": "牛马",
            "matchForms": [
              {
                "text": "牛马",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "牛马",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.q1": {
            "cardId": "outdoor-sports.d.q1",
            "displayText": "军刀",
            "matchForms": [
              {
                "text": "军刀",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "军刀",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.q2": {
            "cardId": "outdoor-sports.d.q2",
            "displayText": "遇难",
            "matchForms": [
              {
                "text": "遇难",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "遇难",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.q3": {
            "cardId": "outdoor-sports.d.q3",
            "displayText": "充电",
            "matchForms": [
              {
                "text": "充电",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "充电",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.q4": {
            "cardId": "outdoor-sports.d.q4",
            "displayText": "越野",
            "matchForms": [
              {
                "text": "越野",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "越野",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.d.q5": {
            "cardId": "outdoor-sports.d.q5",
            "displayText": "过时",
            "matchForms": [
              {
                "text": "过时",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "过时",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.i1": {
            "cardId": "outdoor-sports.e.i1",
            "displayText": "注意",
            "matchForms": [
              {
                "text": "注意",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "注意",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.i2": {
            "cardId": "outdoor-sports.e.i2",
            "displayText": "日出",
            "matchForms": [
              {
                "text": "日出",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "日出",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.i3": {
            "cardId": "outdoor-sports.e.i3",
            "displayText": "瞬间",
            "matchForms": [
              {
                "text": "瞬间",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "瞬间",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.i4": {
            "cardId": "outdoor-sports.e.i4",
            "displayText": "昏迷",
            "matchForms": [
              {
                "text": "昏迷",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "昏迷",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.q1": {
            "cardId": "outdoor-sports.e.q1",
            "displayText": "饥饿",
            "matchForms": [
              {
                "text": "饥饿",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "饥饿",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.q2": {
            "cardId": "outdoor-sports.e.q2",
            "displayText": "帽子",
            "matchForms": [
              {
                "text": "帽子",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "帽子",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.q3": {
            "cardId": "outdoor-sports.e.q3",
            "displayText": "愚蠢",
            "matchForms": [
              {
                "text": "愚蠢",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "愚蠢",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.q4": {
            "cardId": "outdoor-sports.e.q4",
            "displayText": "路线",
            "matchForms": [
              {
                "text": "路线",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "路线",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.e.q5": {
            "cardId": "outdoor-sports.e.q5",
            "displayText": "收费",
            "matchForms": [
              {
                "text": "收费",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "收费",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.r.1": {
            "cardId": "outdoor-sports.r.1",
            "displayText": "湖边",
            "matchForms": [
              {
                "text": "湖边",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "湖边",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.r.2": {
            "cardId": "outdoor-sports.r.2",
            "displayText": "公里",
            "matchForms": [
              {
                "text": "公里",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "公里",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.r.3": {
            "cardId": "outdoor-sports.r.3",
            "displayText": "安全",
            "matchForms": [
              {
                "text": "安全",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "安全",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.r.4": {
            "cardId": "outdoor-sports.r.4",
            "displayText": "晴天",
            "matchForms": [
              {
                "text": "晴天",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "晴天",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "outdoor-sports.r.5": {
            "cardId": "outdoor-sports.r.5",
            "displayText": "自然",
            "matchForms": [
              {
                "text": "自然",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "自然",
              "en": "__TODO_TRANSLATION__"
            }
          }
        },
        "packets": [
          {
            "packetId": "outdoor-sports.packet-a",
            "initial": [
              "outdoor-sports.a.i1",
              "outdoor-sports.a.i2",
              "outdoor-sports.a.i3",
              "outdoor-sports.a.i4"
            ],
            "penalty": [
              "outdoor-sports.a.q1",
              "outdoor-sports.a.q2",
              "outdoor-sports.a.q3",
              "outdoor-sports.a.q4",
              "outdoor-sports.a.q5"
            ]
          },
          {
            "packetId": "outdoor-sports.packet-b",
            "initial": [
              "outdoor-sports.b.i1",
              "outdoor-sports.b.i2",
              "outdoor-sports.b.i3",
              "outdoor-sports.b.i4"
            ],
            "penalty": [
              "outdoor-sports.b.q1",
              "outdoor-sports.b.q2",
              "outdoor-sports.b.q3",
              "outdoor-sports.b.q4",
              "outdoor-sports.b.q5"
            ]
          },
          {
            "packetId": "outdoor-sports.packet-c",
            "initial": [
              "outdoor-sports.c.i1",
              "outdoor-sports.c.i2",
              "outdoor-sports.c.i3",
              "outdoor-sports.c.i4"
            ],
            "penalty": [
              "outdoor-sports.c.q1",
              "outdoor-sports.c.q2",
              "outdoor-sports.c.q3",
              "outdoor-sports.c.q4",
              "outdoor-sports.c.q5"
            ]
          },
          {
            "packetId": "outdoor-sports.packet-d",
            "initial": [
              "outdoor-sports.d.i1",
              "outdoor-sports.d.i2",
              "outdoor-sports.d.i3",
              "outdoor-sports.d.i4"
            ],
            "penalty": [
              "outdoor-sports.d.q1",
              "outdoor-sports.d.q2",
              "outdoor-sports.d.q3",
              "outdoor-sports.d.q4",
              "outdoor-sports.d.q5"
            ]
          },
          {
            "packetId": "outdoor-sports.packet-e",
            "initial": [
              "outdoor-sports.e.i1",
              "outdoor-sports.e.i2",
              "outdoor-sports.e.i3",
              "outdoor-sports.e.i4"
            ],
            "penalty": [
              "outdoor-sports.e.q1",
              "outdoor-sports.e.q2",
              "outdoor-sports.e.q3",
              "outdoor-sports.e.q4",
              "outdoor-sports.e.q5"
            ]
          }
        ],
        "reserves": [
          "outdoor-sports.r.1",
          "outdoor-sports.r.2",
          "outdoor-sports.r.3",
          "outdoor-sports.r.4",
          "outdoor-sports.r.5"
        ],
        "allowedLineups": {
          "3": [
            {
              "lineupId": "outdoor-sports.lineup-3-ace",
              "packetIds": [
                "outdoor-sports.packet-a",
                "outdoor-sports.packet-c",
                "outdoor-sports.packet-e"
              ]
            }
          ],
          "4": [
            {
              "lineupId": "outdoor-sports.lineup-4-abde",
              "packetIds": [
                "outdoor-sports.packet-a",
                "outdoor-sports.packet-b",
                "outdoor-sports.packet-d",
                "outdoor-sports.packet-e"
              ]
            }
          ],
          "5": [
            {
              "lineupId": "outdoor-sports.lineup-5-abcde",
              "packetIds": [
                "outdoor-sports.packet-a",
                "outdoor-sports.packet-b",
                "outdoor-sports.packet-c",
                "outdoor-sports.packet-d",
                "outdoor-sports.packet-e"
              ]
            }
          ]
        }
      }
    },
    {
      "key": "campus-memories",
      "sourceName": "campus-memories.md",
      "outputName": "campus-memories.candidate.v1.json",
      "catalogRevision": "catalog.campus-memories.candidate-1",
      "theme": {
        "themeId": "theme.campus-memories",
        "themeRevision": "rev.candidate-1",
        "compatibleRulesVersion": "rules-v0.3",
        "compatibleDealVersion": "deal-v1",
        "compatibleMatcherVersion": "matcher-v1",
        "supportedPlayerCounts": [
          3,
          4,
          5
        ],
        "candidateStatus": {
          "stage": "MARKDOWN_SOURCE_CANDIDATE",
          "humanPlaytested": false,
          "approvedForProduction": false,
          "notice": {
            "zh": "候选内容，尚未经过真人桌测，不得视为已平衡或可正式发布。",
            "en": "__TODO_TRANSLATION__"
          }
        },
        "title": {
          "zh": "校园往事",
          "en": "__TODO_TRANSLATION__"
        },
        "scenario": {
          "zh": "回到当年。",
          "en": "__TODO_TRANSLATION__"
        },
        "icebreakers": [
          {
            "icebreakerId": "campus-memories.icebreaker-1",
            "zh": "哪段求学经历最让你怀念？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "campus-memories.icebreaker-2",
            "zh": "你曾经最怕面对什么事情？",
            "en": "__TODO_TRANSLATION__"
          }
        ],
        "cards": {
          "campus-memories.a.i1": {
            "cardId": "campus-memories.a.i1",
            "displayText": "打扫",
            "matchForms": [
              {
                "text": "打扫",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "打扫",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.i2": {
            "cardId": "campus-memories.a.i2",
            "displayText": "专业",
            "matchForms": [
              {
                "text": "专业",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "专业",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.i3": {
            "cardId": "campus-memories.a.i3",
            "displayText": "下课",
            "matchForms": [
              {
                "text": "下课",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "下课",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.i4": {
            "cardId": "campus-memories.a.i4",
            "displayText": "眼保健操",
            "matchForms": [
              {
                "text": "眼保健操",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "眼保健操",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.q1": {
            "cardId": "campus-memories.a.q1",
            "displayText": "排名",
            "matchForms": [
              {
                "text": "排名",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "排名",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.q2": {
            "cardId": "campus-memories.a.q2",
            "displayText": "及格",
            "matchForms": [
              {
                "text": "及格",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "及格",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.q3": {
            "cardId": "campus-memories.a.q3",
            "displayText": "足球",
            "matchForms": [
              {
                "text": "足球",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "足球",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.q4": {
            "cardId": "campus-memories.a.q4",
            "displayText": "留学",
            "matchForms": [
              {
                "text": "留学",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "留学",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.a.q5": {
            "cardId": "campus-memories.a.q5",
            "displayText": "考试",
            "matchForms": [
              {
                "text": "考试",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "考试",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.i1": {
            "cardId": "campus-memories.b.i1",
            "displayText": "同桌",
            "matchForms": [
              {
                "text": "同桌",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "同桌",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.i2": {
            "cardId": "campus-memories.b.i2",
            "displayText": "补课",
            "matchForms": [
              {
                "text": "补课",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "补课",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.i3": {
            "cardId": "campus-memories.b.i3",
            "displayText": "忘记",
            "matchForms": [
              {
                "text": "忘记",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "忘记",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.i4": {
            "cardId": "campus-memories.b.i4",
            "displayText": "外号",
            "matchForms": [
              {
                "text": "外号",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "外号",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.q1": {
            "cardId": "campus-memories.b.q1",
            "displayText": "体育",
            "matchForms": [
              {
                "text": "体育",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "体育",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.q2": {
            "cardId": "campus-memories.b.q2",
            "displayText": "篮球",
            "matchForms": [
              {
                "text": "篮球",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "篮球",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.q3": {
            "cardId": "campus-memories.b.q3",
            "displayText": "零食",
            "matchForms": [
              {
                "text": "零食",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "零食",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.q4": {
            "cardId": "campus-memories.b.q4",
            "displayText": "实验",
            "matchForms": [
              {
                "text": "实验",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "实验",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.b.q5": {
            "cardId": "campus-memories.b.q5",
            "displayText": "值日",
            "matchForms": [
              {
                "text": "值日",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "值日",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.i1": {
            "cardId": "campus-memories.c.i1",
            "displayText": "青春",
            "matchForms": [
              {
                "text": "青春",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "青春",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.i2": {
            "cardId": "campus-memories.c.i2",
            "displayText": "小卖部",
            "matchForms": [
              {
                "text": "小卖部",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "小卖部",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.i3": {
            "cardId": "campus-memories.c.i3",
            "displayText": "粉笔",
            "matchForms": [
              {
                "text": "粉笔",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "粉笔",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.i4": {
            "cardId": "campus-memories.c.i4",
            "displayText": "偶像",
            "matchForms": [
              {
                "text": "偶像",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "偶像",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.q1": {
            "cardId": "campus-memories.c.q1",
            "displayText": "实习",
            "matchForms": [
              {
                "text": "实习",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "实习",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.q2": {
            "cardId": "campus-memories.c.q2",
            "displayText": "铃声",
            "matchForms": [
              {
                "text": "铃声",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "铃声",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.q3": {
            "cardId": "campus-memories.c.q3",
            "displayText": "圆规",
            "matchForms": [
              {
                "text": "圆规",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "圆规",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.q4": {
            "cardId": "campus-memories.c.q4",
            "displayText": "手机",
            "matchForms": [
              {
                "text": "手机",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "手机",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.c.q5": {
            "cardId": "campus-memories.c.q5",
            "displayText": "运动",
            "matchForms": [
              {
                "text": "运动",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "运动",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.i1": {
            "cardId": "campus-memories.d.i1",
            "displayText": "无聊",
            "matchForms": [
              {
                "text": "无聊",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "无聊",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.i2": {
            "cardId": "campus-memories.d.i2",
            "displayText": "期末",
            "matchForms": [
              {
                "text": "期末",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "期末",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.i3": {
            "cardId": "campus-memories.d.i3",
            "displayText": "紧张",
            "matchForms": [
              {
                "text": "紧张",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "紧张",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.i4": {
            "cardId": "campus-memories.d.i4",
            "displayText": "近视",
            "matchForms": [
              {
                "text": "近视",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "近视",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.q1": {
            "cardId": "campus-memories.d.q1",
            "displayText": "遗憾",
            "matchForms": [
              {
                "text": "遗憾",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "遗憾",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.q2": {
            "cardId": "campus-memories.d.q2",
            "displayText": "叛逆",
            "matchForms": [
              {
                "text": "叛逆",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "叛逆",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.q3": {
            "cardId": "campus-memories.d.q3",
            "displayText": "嫉妒",
            "matchForms": [
              {
                "text": "嫉妒",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "嫉妒",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.q4": {
            "cardId": "campus-memories.d.q4",
            "displayText": "作业",
            "matchForms": [
              {
                "text": "作业",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "作业",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.d.q5": {
            "cardId": "campus-memories.d.q5",
            "displayText": "暑假",
            "matchForms": [
              {
                "text": "暑假",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "暑假",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.i1": {
            "cardId": "campus-memories.e.i1",
            "displayText": "广播",
            "matchForms": [
              {
                "text": "广播",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "广播",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.i2": {
            "cardId": "campus-memories.e.i2",
            "displayText": "社团",
            "matchForms": [
              {
                "text": "社团",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "社团",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.i3": {
            "cardId": "campus-memories.e.i3",
            "displayText": "迟到",
            "matchForms": [
              {
                "text": "迟到",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "迟到",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.i4": {
            "cardId": "campus-memories.e.i4",
            "displayText": "红领巾",
            "matchForms": [
              {
                "text": "红领巾",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "红领巾",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.q1": {
            "cardId": "campus-memories.e.q1",
            "displayText": "黑板",
            "matchForms": [
              {
                "text": "黑板",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "黑板",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.q2": {
            "cardId": "campus-memories.e.q2",
            "displayText": "熄灯",
            "matchForms": [
              {
                "text": "熄灯",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "熄灯",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.q3": {
            "cardId": "campus-memories.e.q3",
            "displayText": "网吧",
            "matchForms": [
              {
                "text": "网吧",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "网吧",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.q4": {
            "cardId": "campus-memories.e.q4",
            "displayText": "占座",
            "matchForms": [
              {
                "text": "占座",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "占座",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.e.q5": {
            "cardId": "campus-memories.e.q5",
            "displayText": "操场",
            "matchForms": [
              {
                "text": "操场",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "操场",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.r.1": {
            "cardId": "campus-memories.r.1",
            "displayText": "作弊",
            "matchForms": [
              {
                "text": "作弊",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "作弊",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.r.2": {
            "cardId": "campus-memories.r.2",
            "displayText": "校服",
            "matchForms": [
              {
                "text": "校服",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "校服",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.r.3": {
            "cardId": "campus-memories.r.3",
            "displayText": "食堂",
            "matchForms": [
              {
                "text": "食堂",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "食堂",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.r.4": {
            "cardId": "campus-memories.r.4",
            "displayText": "早操",
            "matchForms": [
              {
                "text": "早操",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "早操",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "campus-memories.r.5": {
            "cardId": "campus-memories.r.5",
            "displayText": "转学",
            "matchForms": [
              {
                "text": "转学",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "转学",
              "en": "__TODO_TRANSLATION__"
            }
          }
        },
        "packets": [
          {
            "packetId": "campus-memories.packet-a",
            "initial": [
              "campus-memories.a.i1",
              "campus-memories.a.i2",
              "campus-memories.a.i3",
              "campus-memories.a.i4"
            ],
            "penalty": [
              "campus-memories.a.q1",
              "campus-memories.a.q2",
              "campus-memories.a.q3",
              "campus-memories.a.q4",
              "campus-memories.a.q5"
            ]
          },
          {
            "packetId": "campus-memories.packet-b",
            "initial": [
              "campus-memories.b.i1",
              "campus-memories.b.i2",
              "campus-memories.b.i3",
              "campus-memories.b.i4"
            ],
            "penalty": [
              "campus-memories.b.q1",
              "campus-memories.b.q2",
              "campus-memories.b.q3",
              "campus-memories.b.q4",
              "campus-memories.b.q5"
            ]
          },
          {
            "packetId": "campus-memories.packet-c",
            "initial": [
              "campus-memories.c.i1",
              "campus-memories.c.i2",
              "campus-memories.c.i3",
              "campus-memories.c.i4"
            ],
            "penalty": [
              "campus-memories.c.q1",
              "campus-memories.c.q2",
              "campus-memories.c.q3",
              "campus-memories.c.q4",
              "campus-memories.c.q5"
            ]
          },
          {
            "packetId": "campus-memories.packet-d",
            "initial": [
              "campus-memories.d.i1",
              "campus-memories.d.i2",
              "campus-memories.d.i3",
              "campus-memories.d.i4"
            ],
            "penalty": [
              "campus-memories.d.q1",
              "campus-memories.d.q2",
              "campus-memories.d.q3",
              "campus-memories.d.q4",
              "campus-memories.d.q5"
            ]
          },
          {
            "packetId": "campus-memories.packet-e",
            "initial": [
              "campus-memories.e.i1",
              "campus-memories.e.i2",
              "campus-memories.e.i3",
              "campus-memories.e.i4"
            ],
            "penalty": [
              "campus-memories.e.q1",
              "campus-memories.e.q2",
              "campus-memories.e.q3",
              "campus-memories.e.q4",
              "campus-memories.e.q5"
            ]
          }
        ],
        "reserves": [
          "campus-memories.r.1",
          "campus-memories.r.2",
          "campus-memories.r.3",
          "campus-memories.r.4",
          "campus-memories.r.5"
        ],
        "allowedLineups": {
          "3": [
            {
              "lineupId": "campus-memories.lineup-3-ace",
              "packetIds": [
                "campus-memories.packet-a",
                "campus-memories.packet-c",
                "campus-memories.packet-e"
              ]
            }
          ],
          "4": [
            {
              "lineupId": "campus-memories.lineup-4-abde",
              "packetIds": [
                "campus-memories.packet-a",
                "campus-memories.packet-b",
                "campus-memories.packet-d",
                "campus-memories.packet-e"
              ]
            }
          ],
          "5": [
            {
              "lineupId": "campus-memories.lineup-5-abcde",
              "packetIds": [
                "campus-memories.packet-a",
                "campus-memories.packet-b",
                "campus-memories.packet-c",
                "campus-memories.packet-d",
                "campus-memories.packet-e"
              ]
            }
          ]
        }
      }
    },
    {
      "key": "home-decor",
      "sourceName": "home-decor.md",
      "outputName": "home-decor.candidate.v1.json",
      "catalogRevision": "catalog.home-decor.candidate-1",
      "theme": {
        "themeId": "theme.home-decor",
        "themeRevision": "rev.candidate-1",
        "compatibleRulesVersion": "rules-v0.3",
        "compatibleDealVersion": "deal-v1",
        "compatibleMatcherVersion": "matcher-v1",
        "supportedPlayerCounts": [
          3,
          4,
          5
        ],
        "candidateStatus": {
          "stage": "MARKDOWN_SOURCE_CANDIDATE",
          "humanPlaytested": false,
          "approvedForProduction": false,
          "notice": {
            "zh": "候选内容，尚未经过真人桌测，不得视为已平衡或可正式发布。",
            "en": "__TODO_TRANSLATION__"
          }
        },
        "title": {
          "zh": "理想住处",
          "en": "__TODO_TRANSLATION__"
        },
        "scenario": {
          "zh": "如果金钱无限，你将打造怎样的家？",
          "en": "__TODO_TRANSLATION__"
        },
        "icebreakers": [
          {
            "icebreakerId": "home-decor.icebreaker-1",
            "zh": "高层？别墅？庄园？公海上的钻井平台？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "home-decor.icebreaker-2",
            "zh": "多少房间？每个用来做什么？要种地吗？",
            "en": "__TODO_TRANSLATION__"
          }
        ],
        "cards": {
          "home-decor.a.i1": {
            "cardId": "home-decor.a.i1",
            "displayText": "隔音",
            "matchForms": [
              {
                "text": "隔音",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "隔音",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.i2": {
            "cardId": "home-decor.a.i2",
            "displayText": "种菜",
            "matchForms": [
              {
                "text": "种菜",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "种菜",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.i3": {
            "cardId": "home-decor.a.i3",
            "displayText": "养老",
            "matchForms": [
              {
                "text": "养老",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "养老",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.i4": {
            "cardId": "home-decor.a.i4",
            "displayText": "鱼缸",
            "matchForms": [
              {
                "text": "鱼缸",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "鱼缸",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.q1": {
            "cardId": "home-decor.a.q1",
            "displayText": "智能",
            "matchForms": [
              {
                "text": "智能",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "智能",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.q2": {
            "cardId": "home-decor.a.q2",
            "displayText": "吊顶",
            "matchForms": [
              {
                "text": "吊顶",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "吊顶",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.q3": {
            "cardId": "home-decor.a.q3",
            "displayText": "甲醛",
            "matchForms": [
              {
                "text": "甲醛",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "甲醛",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.q4": {
            "cardId": "home-decor.a.q4",
            "displayText": "梦想",
            "matchForms": [
              {
                "text": "梦想",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "梦想",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.a.q5": {
            "cardId": "home-decor.a.q5",
            "displayText": "浴缸",
            "matchForms": [
              {
                "text": "浴缸",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "浴缸",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.i1": {
            "cardId": "home-decor.b.i1",
            "displayText": "收纳",
            "matchForms": [
              {
                "text": "收纳",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "收纳",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.i2": {
            "cardId": "home-decor.b.i2",
            "displayText": "钓鱼",
            "matchForms": [
              {
                "text": "钓鱼",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "钓鱼",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.i3": {
            "cardId": "home-decor.b.i3",
            "displayText": "聚会",
            "matchForms": [
              {
                "text": "聚会",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "聚会",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.i4": {
            "cardId": "home-decor.b.i4",
            "displayText": "监控",
            "matchForms": [
              {
                "text": "监控",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "监控",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.q1": {
            "cardId": "home-decor.b.q1",
            "displayText": "物业",
            "matchForms": [
              {
                "text": "物业",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "物业",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.q2": {
            "cardId": "home-decor.b.q2",
            "displayText": "宠物",
            "matchForms": [
              {
                "text": "宠物",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "宠物",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.q3": {
            "cardId": "home-decor.b.q3",
            "displayText": "投诉",
            "matchForms": [
              {
                "text": "投诉",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "投诉",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.q4": {
            "cardId": "home-decor.b.q4",
            "displayText": "飘窗",
            "matchForms": [
              {
                "text": "飘窗",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "飘窗",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.b.q5": {
            "cardId": "home-decor.b.q5",
            "displayText": "通风",
            "matchForms": [
              {
                "text": "通风",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "通风",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.i1": {
            "cardId": "home-decor.c.i1",
            "displayText": "沙发",
            "matchForms": [
              {
                "text": "沙发",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "沙发",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.i2": {
            "cardId": "home-decor.c.i2",
            "displayText": "洗碗",
            "matchForms": [
              {
                "text": "洗碗",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "洗碗",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.i3": {
            "cardId": "home-decor.c.i3",
            "displayText": "阳光",
            "matchForms": [
              {
                "text": "阳光",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "阳光",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.i4": {
            "cardId": "home-decor.c.i4",
            "displayText": "回声",
            "matchForms": [
              {
                "text": "回声",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "回声",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.q1": {
            "cardId": "home-decor.c.q1",
            "displayText": "开关",
            "matchForms": [
              {
                "text": "开关",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "开关",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.q2": {
            "cardId": "home-decor.c.q2",
            "displayText": "钥匙",
            "matchForms": [
              {
                "text": "钥匙",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "钥匙",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.q3": {
            "cardId": "home-decor.c.q3",
            "displayText": "地下室",
            "matchForms": [
              {
                "text": "地下室",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "地下室",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.q4": {
            "cardId": "home-decor.c.q4",
            "displayText": "风格",
            "matchForms": [
              {
                "text": "风格",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "风格",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.c.q5": {
            "cardId": "home-decor.c.q5",
            "displayText": "农场",
            "matchForms": [
              {
                "text": "农场",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "农场",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.i1": {
            "cardId": "home-decor.d.i1",
            "displayText": "游泳",
            "matchForms": [
              {
                "text": "游泳",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "游泳",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.i2": {
            "cardId": "home-decor.d.i2",
            "displayText": "面积",
            "matchForms": [
              {
                "text": "面积",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "面积",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.i3": {
            "cardId": "home-decor.d.i3",
            "displayText": "合适",
            "matchForms": [
              {
                "text": "合适",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "合适",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.i4": {
            "cardId": "home-decor.d.i4",
            "displayText": "噪音",
            "matchForms": [
              {
                "text": "噪音",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "噪音",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.q1": {
            "cardId": "home-decor.d.q1",
            "displayText": "玄关",
            "matchForms": [
              {
                "text": "玄关",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "玄关",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.q2": {
            "cardId": "home-decor.d.q2",
            "displayText": "龙头",
            "matchForms": [
              {
                "text": "龙头",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "龙头",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.q3": {
            "cardId": "home-decor.d.q3",
            "displayText": "乱跑",
            "matchForms": [
              {
                "text": "乱跑",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "乱跑",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.q4": {
            "cardId": "home-decor.d.q4",
            "displayText": "海边",
            "matchForms": [
              {
                "text": "海边",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "海边",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.d.q5": {
            "cardId": "home-decor.d.q5",
            "displayText": "承重",
            "matchForms": [
              {
                "text": "承重",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "承重",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.i1": {
            "cardId": "home-decor.e.i1",
            "displayText": "阳台",
            "matchForms": [
              {
                "text": "阳台",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "阳台",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.i2": {
            "cardId": "home-decor.e.i2",
            "displayText": "马桶",
            "matchForms": [
              {
                "text": "马桶",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "马桶",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.i3": {
            "cardId": "home-decor.e.i3",
            "displayText": "后悔",
            "matchForms": [
              {
                "text": "后悔",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "后悔",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.i4": {
            "cardId": "home-decor.e.i4",
            "displayText": "灰尘",
            "matchForms": [
              {
                "text": "灰尘",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "灰尘",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.q1": {
            "cardId": "home-decor.e.q1",
            "displayText": "花园",
            "matchForms": [
              {
                "text": "花园",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "花园",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.q2": {
            "cardId": "home-decor.e.q2",
            "displayText": "户型",
            "matchForms": [
              {
                "text": "户型",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "户型",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.q3": {
            "cardId": "home-decor.e.q3",
            "displayText": "天花板",
            "matchForms": [
              {
                "text": "天花板",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "天花板",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.q4": {
            "cardId": "home-decor.e.q4",
            "displayText": "冰箱",
            "matchForms": [
              {
                "text": "冰箱",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "冰箱",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.e.q5": {
            "cardId": "home-decor.e.q5",
            "displayText": "气候",
            "matchForms": [
              {
                "text": "气候",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "气候",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.r.1": {
            "cardId": "home-decor.r.1",
            "displayText": "弹琴",
            "matchForms": [
              {
                "text": "弹琴",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "弹琴",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.r.2": {
            "cardId": "home-decor.r.2",
            "displayText": "安静",
            "matchForms": [
              {
                "text": "安静",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "安静",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.r.3": {
            "cardId": "home-decor.r.3",
            "displayText": "样板",
            "matchForms": [
              {
                "text": "样板",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "样板",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.r.4": {
            "cardId": "home-decor.r.4",
            "displayText": "一言难尽",
            "matchForms": [
              {
                "text": "一言难尽",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "一言难尽",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "home-decor.r.5": {
            "cardId": "home-decor.r.5",
            "displayText": "热水器",
            "matchForms": [
              {
                "text": "热水器",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "热水器",
              "en": "__TODO_TRANSLATION__"
            }
          }
        },
        "packets": [
          {
            "packetId": "home-decor.packet-a",
            "initial": [
              "home-decor.a.i1",
              "home-decor.a.i2",
              "home-decor.a.i3",
              "home-decor.a.i4"
            ],
            "penalty": [
              "home-decor.a.q1",
              "home-decor.a.q2",
              "home-decor.a.q3",
              "home-decor.a.q4",
              "home-decor.a.q5"
            ]
          },
          {
            "packetId": "home-decor.packet-b",
            "initial": [
              "home-decor.b.i1",
              "home-decor.b.i2",
              "home-decor.b.i3",
              "home-decor.b.i4"
            ],
            "penalty": [
              "home-decor.b.q1",
              "home-decor.b.q2",
              "home-decor.b.q3",
              "home-decor.b.q4",
              "home-decor.b.q5"
            ]
          },
          {
            "packetId": "home-decor.packet-c",
            "initial": [
              "home-decor.c.i1",
              "home-decor.c.i2",
              "home-decor.c.i3",
              "home-decor.c.i4"
            ],
            "penalty": [
              "home-decor.c.q1",
              "home-decor.c.q2",
              "home-decor.c.q3",
              "home-decor.c.q4",
              "home-decor.c.q5"
            ]
          },
          {
            "packetId": "home-decor.packet-d",
            "initial": [
              "home-decor.d.i1",
              "home-decor.d.i2",
              "home-decor.d.i3",
              "home-decor.d.i4"
            ],
            "penalty": [
              "home-decor.d.q1",
              "home-decor.d.q2",
              "home-decor.d.q3",
              "home-decor.d.q4",
              "home-decor.d.q5"
            ]
          },
          {
            "packetId": "home-decor.packet-e",
            "initial": [
              "home-decor.e.i1",
              "home-decor.e.i2",
              "home-decor.e.i3",
              "home-decor.e.i4"
            ],
            "penalty": [
              "home-decor.e.q1",
              "home-decor.e.q2",
              "home-decor.e.q3",
              "home-decor.e.q4",
              "home-decor.e.q5"
            ]
          }
        ],
        "reserves": [
          "home-decor.r.1",
          "home-decor.r.2",
          "home-decor.r.3",
          "home-decor.r.4",
          "home-decor.r.5"
        ],
        "allowedLineups": {
          "3": [
            {
              "lineupId": "home-decor.lineup-3-ace",
              "packetIds": [
                "home-decor.packet-a",
                "home-decor.packet-c",
                "home-decor.packet-e"
              ]
            }
          ],
          "4": [
            {
              "lineupId": "home-decor.lineup-4-abde",
              "packetIds": [
                "home-decor.packet-a",
                "home-decor.packet-b",
                "home-decor.packet-d",
                "home-decor.packet-e"
              ]
            }
          ],
          "5": [
            {
              "lineupId": "home-decor.lineup-5-abcde",
              "packetIds": [
                "home-decor.packet-a",
                "home-decor.packet-b",
                "home-decor.packet-c",
                "home-decor.packet-d",
                "home-decor.packet-e"
              ]
            }
          ]
        }
      }
    },
    {
      "key": "hotpot-gathering",
      "sourceName": "hotpot-gathering.md",
      "outputName": "hotpot-gathering.candidate.v1.json",
      "catalogRevision": "catalog.hotpot-gathering.candidate-1",
      "theme": {
        "themeId": "theme.hotpot-gathering",
        "themeRevision": "rev.candidate-1",
        "compatibleRulesVersion": "rules-v0.3",
        "compatibleDealVersion": "deal-v1",
        "compatibleMatcherVersion": "matcher-v1",
        "supportedPlayerCounts": [
          3,
          4,
          5
        ],
        "candidateStatus": {
          "stage": "MARKDOWN_SOURCE_CANDIDATE",
          "humanPlaytested": false,
          "approvedForProduction": false,
          "notice": {
            "zh": "候选内容，尚未经过真人桌测，不得视为已平衡或可正式发布。",
            "en": "__TODO_TRANSLATION__"
          }
        },
        "title": {
          "zh": "吃火锅",
          "en": "__TODO_TRANSLATION__"
        },
        "scenario": {
          "zh": "热气氤氲里的无限卡路里。",
          "en": "__TODO_TRANSLATION__"
        },
        "icebreakers": [
          {
            "icebreakerId": "hotpot-gathering.icebreaker-1",
            "zh": "你最期待桌上出现哪样东西？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "hotpot-gathering.icebreaker-2",
            "zh": "哪一家火锅店你最常去？",
            "en": "__TODO_TRANSLATION__"
          }
        ],
        "cards": {
          "hotpot-gathering.a.i1": {
            "cardId": "hotpot-gathering.a.i1",
            "displayText": "买单",
            "matchForms": [
              {
                "text": "买单",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "买单",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.i2": {
            "cardId": "hotpot-gathering.a.i2",
            "displayText": "牛油",
            "matchForms": [
              {
                "text": "牛油",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "牛油",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.i3": {
            "cardId": "hotpot-gathering.a.i3",
            "displayText": "不辣",
            "matchForms": [
              {
                "text": "不辣",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "不辣",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.i4": {
            "cardId": "hotpot-gathering.a.i4",
            "displayText": "成都",
            "matchForms": [
              {
                "text": "成都",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "成都",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.q1": {
            "cardId": "hotpot-gathering.a.q1",
            "displayText": "重庆",
            "matchForms": [
              {
                "text": "重庆",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "重庆",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.q2": {
            "cardId": "hotpot-gathering.a.q2",
            "displayText": "花椒",
            "matchForms": [
              {
                "text": "花椒",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "花椒",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.q3": {
            "cardId": "hotpot-gathering.a.q3",
            "displayText": "夜宵",
            "matchForms": [
              {
                "text": "夜宵",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "夜宵",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.q4": {
            "cardId": "hotpot-gathering.a.q4",
            "displayText": "周末",
            "matchForms": [
              {
                "text": "周末",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "周末",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.a.q5": {
            "cardId": "hotpot-gathering.a.q5",
            "displayText": "体重",
            "matchForms": [
              {
                "text": "体重",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "体重",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.i1": {
            "cardId": "hotpot-gathering.b.i1",
            "displayText": "午餐肉",
            "matchForms": [
              {
                "text": "午餐肉",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "午餐肉",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.i2": {
            "cardId": "hotpot-gathering.b.i2",
            "displayText": "油碟",
            "matchForms": [
              {
                "text": "油碟",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "油碟",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.i3": {
            "cardId": "hotpot-gathering.b.i3",
            "displayText": "客气",
            "matchForms": [
              {
                "text": "客气",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "客气",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.i4": {
            "cardId": "hotpot-gathering.b.i4",
            "displayText": "喝醉",
            "matchForms": [
              {
                "text": "喝醉",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "喝醉",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.q1": {
            "cardId": "hotpot-gathering.b.q1",
            "displayText": "牙签",
            "matchForms": [
              {
                "text": "牙签",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "牙签",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.q2": {
            "cardId": "hotpot-gathering.b.q2",
            "displayText": "纸巾",
            "matchForms": [
              {
                "text": "纸巾",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "纸巾",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.q3": {
            "cardId": "hotpot-gathering.b.q3",
            "displayText": "自助",
            "matchForms": [
              {
                "text": "自助",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "自助",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.q4": {
            "cardId": "hotpot-gathering.b.q4",
            "displayText": "干碟",
            "matchForms": [
              {
                "text": "干碟",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "干碟",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.b.q5": {
            "cardId": "hotpot-gathering.b.q5",
            "displayText": "团购",
            "matchForms": [
              {
                "text": "团购",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "团购",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.i1": {
            "cardId": "hotpot-gathering.c.i1",
            "displayText": "粉条",
            "matchForms": [
              {
                "text": "粉条",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "粉条",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.i2": {
            "cardId": "hotpot-gathering.c.i2",
            "displayText": "肚子",
            "matchForms": [
              {
                "text": "肚子",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "肚子",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.i3": {
            "cardId": "hotpot-gathering.c.i3",
            "displayText": "随便",
            "matchForms": [
              {
                "text": "随便",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "随便",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.i4": {
            "cardId": "hotpot-gathering.c.i4",
            "displayText": "朋友",
            "matchForms": [
              {
                "text": "朋友",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "朋友",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.q1": {
            "cardId": "hotpot-gathering.c.q1",
            "displayText": "香菜",
            "matchForms": [
              {
                "text": "香菜",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "香菜",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.q2": {
            "cardId": "hotpot-gathering.c.q2",
            "displayText": "分量",
            "matchForms": [
              {
                "text": "分量",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "分量",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.q3": {
            "cardId": "hotpot-gathering.c.q3",
            "displayText": "新鲜",
            "matchForms": [
              {
                "text": "新鲜",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "新鲜",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.q4": {
            "cardId": "hotpot-gathering.c.q4",
            "displayText": "夏天",
            "matchForms": [
              {
                "text": "夏天",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "夏天",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.c.q5": {
            "cardId": "hotpot-gathering.c.q5",
            "displayText": "主食",
            "matchForms": [
              {
                "text": "主食",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "主食",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.i1": {
            "cardId": "hotpot-gathering.d.i1",
            "displayText": "毛肚",
            "matchForms": [
              {
                "text": "毛肚",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "毛肚",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.i2": {
            "cardId": "hotpot-gathering.d.i2",
            "displayText": "肥牛",
            "matchForms": [
              {
                "text": "肥牛",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "肥牛",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.i3": {
            "cardId": "hotpot-gathering.d.i3",
            "displayText": "加冰",
            "matchForms": [
              {
                "text": "加冰",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "加冰",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.i4": {
            "cardId": "hotpot-gathering.d.i4",
            "displayText": "眼镜",
            "matchForms": [
              {
                "text": "眼镜",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "眼镜",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.q1": {
            "cardId": "hotpot-gathering.d.q1",
            "displayText": "仪式",
            "matchForms": [
              {
                "text": "仪式",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "仪式",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.q2": {
            "cardId": "hotpot-gathering.d.q2",
            "displayText": "麻酱",
            "matchForms": [
              {
                "text": "麻酱",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "麻酱",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.q3": {
            "cardId": "hotpot-gathering.d.q3",
            "displayText": "过敏",
            "matchForms": [
              {
                "text": "过敏",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "过敏",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.q4": {
            "cardId": "hotpot-gathering.d.q4",
            "displayText": "烧烤",
            "matchForms": [
              {
                "text": "烧烤",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "烧烤",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.d.q5": {
            "cardId": "hotpot-gathering.d.q5",
            "displayText": "热闹",
            "matchForms": [
              {
                "text": "热闹",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "热闹",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.i1": {
            "cardId": "hotpot-gathering.e.i1",
            "displayText": "聚会",
            "matchForms": [
              {
                "text": "聚会",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "聚会",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.i2": {
            "cardId": "hotpot-gathering.e.i2",
            "displayText": "腐竹",
            "matchForms": [
              {
                "text": "腐竹",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "腐竹",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.i3": {
            "cardId": "hotpot-gathering.e.i3",
            "displayText": "干杯",
            "matchForms": [
              {
                "text": "干杯",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "干杯",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.i4": {
            "cardId": "hotpot-gathering.e.i4",
            "displayText": "健身",
            "matchForms": [
              {
                "text": "健身",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "健身",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.q1": {
            "cardId": "hotpot-gathering.e.q1",
            "displayText": "包间",
            "matchForms": [
              {
                "text": "包间",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "包间",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.q2": {
            "cardId": "hotpot-gathering.e.q2",
            "displayText": "刘海",
            "matchForms": [
              {
                "text": "刘海",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "刘海",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.q3": {
            "cardId": "hotpot-gathering.e.q3",
            "displayText": "豆腐",
            "matchForms": [
              {
                "text": "豆腐",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "豆腐",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.q4": {
            "cardId": "hotpot-gathering.e.q4",
            "displayText": "谎话",
            "matchForms": [
              {
                "text": "谎话",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "谎话",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.e.q5": {
            "cardId": "hotpot-gathering.e.q5",
            "displayText": "排队",
            "matchForms": [
              {
                "text": "排队",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "排队",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.r.1": {
            "cardId": "hotpot-gathering.r.1",
            "displayText": "优惠",
            "matchForms": [
              {
                "text": "优惠",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "优惠",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.r.2": {
            "cardId": "hotpot-gathering.r.2",
            "displayText": "丸子",
            "matchForms": [
              {
                "text": "丸子",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "丸子",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.r.3": {
            "cardId": "hotpot-gathering.r.3",
            "displayText": "啤酒",
            "matchForms": [
              {
                "text": "啤酒",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "啤酒",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.r.4": {
            "cardId": "hotpot-gathering.r.4",
            "displayText": "鸳鸯",
            "matchForms": [
              {
                "text": "鸳鸯",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "鸳鸯",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "hotpot-gathering.r.5": {
            "cardId": "hotpot-gathering.r.5",
            "displayText": "黄喉",
            "matchForms": [
              {
                "text": "黄喉",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "黄喉",
              "en": "__TODO_TRANSLATION__"
            }
          }
        },
        "packets": [
          {
            "packetId": "hotpot-gathering.packet-a",
            "initial": [
              "hotpot-gathering.a.i1",
              "hotpot-gathering.a.i2",
              "hotpot-gathering.a.i3",
              "hotpot-gathering.a.i4"
            ],
            "penalty": [
              "hotpot-gathering.a.q1",
              "hotpot-gathering.a.q2",
              "hotpot-gathering.a.q3",
              "hotpot-gathering.a.q4",
              "hotpot-gathering.a.q5"
            ]
          },
          {
            "packetId": "hotpot-gathering.packet-b",
            "initial": [
              "hotpot-gathering.b.i1",
              "hotpot-gathering.b.i2",
              "hotpot-gathering.b.i3",
              "hotpot-gathering.b.i4"
            ],
            "penalty": [
              "hotpot-gathering.b.q1",
              "hotpot-gathering.b.q2",
              "hotpot-gathering.b.q3",
              "hotpot-gathering.b.q4",
              "hotpot-gathering.b.q5"
            ]
          },
          {
            "packetId": "hotpot-gathering.packet-c",
            "initial": [
              "hotpot-gathering.c.i1",
              "hotpot-gathering.c.i2",
              "hotpot-gathering.c.i3",
              "hotpot-gathering.c.i4"
            ],
            "penalty": [
              "hotpot-gathering.c.q1",
              "hotpot-gathering.c.q2",
              "hotpot-gathering.c.q3",
              "hotpot-gathering.c.q4",
              "hotpot-gathering.c.q5"
            ]
          },
          {
            "packetId": "hotpot-gathering.packet-d",
            "initial": [
              "hotpot-gathering.d.i1",
              "hotpot-gathering.d.i2",
              "hotpot-gathering.d.i3",
              "hotpot-gathering.d.i4"
            ],
            "penalty": [
              "hotpot-gathering.d.q1",
              "hotpot-gathering.d.q2",
              "hotpot-gathering.d.q3",
              "hotpot-gathering.d.q4",
              "hotpot-gathering.d.q5"
            ]
          },
          {
            "packetId": "hotpot-gathering.packet-e",
            "initial": [
              "hotpot-gathering.e.i1",
              "hotpot-gathering.e.i2",
              "hotpot-gathering.e.i3",
              "hotpot-gathering.e.i4"
            ],
            "penalty": [
              "hotpot-gathering.e.q1",
              "hotpot-gathering.e.q2",
              "hotpot-gathering.e.q3",
              "hotpot-gathering.e.q4",
              "hotpot-gathering.e.q5"
            ]
          }
        ],
        "reserves": [
          "hotpot-gathering.r.1",
          "hotpot-gathering.r.2",
          "hotpot-gathering.r.3",
          "hotpot-gathering.r.4",
          "hotpot-gathering.r.5"
        ],
        "allowedLineups": {
          "3": [
            {
              "lineupId": "hotpot-gathering.lineup-3-ace",
              "packetIds": [
                "hotpot-gathering.packet-a",
                "hotpot-gathering.packet-c",
                "hotpot-gathering.packet-e"
              ]
            }
          ],
          "4": [
            {
              "lineupId": "hotpot-gathering.lineup-4-abde",
              "packetIds": [
                "hotpot-gathering.packet-a",
                "hotpot-gathering.packet-b",
                "hotpot-gathering.packet-d",
                "hotpot-gathering.packet-e"
              ]
            }
          ],
          "5": [
            {
              "lineupId": "hotpot-gathering.lineup-5-abcde",
              "packetIds": [
                "hotpot-gathering.packet-a",
                "hotpot-gathering.packet-b",
                "hotpot-gathering.packet-c",
                "hotpot-gathering.packet-d",
                "hotpot-gathering.packet-e"
              ]
            }
          ]
        }
      }
    },
    {
      "key": "office-life",
      "sourceName": "office-life.md",
      "outputName": "office-life.candidate.v1.json",
      "catalogRevision": "catalog.office-life.candidate-1",
      "theme": {
        "themeId": "theme.office-life",
        "themeRevision": "rev.candidate-1",
        "compatibleRulesVersion": "rules-v0.3",
        "compatibleDealVersion": "deal-v1",
        "compatibleMatcherVersion": "matcher-v1",
        "supportedPlayerCounts": [
          3,
          4,
          5
        ],
        "candidateStatus": {
          "stage": "MARKDOWN_SOURCE_CANDIDATE",
          "humanPlaytested": false,
          "approvedForProduction": false,
          "notice": {
            "zh": "候选内容，尚未经过真人桌测，不得视为已平衡或可正式发布。",
            "en": "__TODO_TRANSLATION__"
          }
        },
        "title": {
          "zh": "理想的工作",
          "en": "__TODO_TRANSLATION__"
        },
        "scenario": {
          "zh": "坐在自己的工位，你陷入一场白日梦",
          "en": "__TODO_TRANSLATION__"
        },
        "icebreakers": [
          {
            "icebreakerId": "office-life.icebreaker-1",
            "zh": "你理想的职业是？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "office-life.icebreaker-2",
            "zh": "一天的工作应该如何度过？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "office-life.icebreaker-3",
            "zh": "最愿意接受的挑战？",
            "en": "__TODO_TRANSLATION__"
          }
        ],
        "cards": {
          "office-life.a.i1": {
            "cardId": "office-life.a.i1",
            "displayText": "咖啡",
            "matchForms": [
              {
                "text": "咖啡",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "咖啡",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.i2": {
            "cardId": "office-life.a.i2",
            "displayText": "优先",
            "matchForms": [
              {
                "text": "优先",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "优先",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.i3": {
            "cardId": "office-life.a.i3",
            "displayText": "辛苦",
            "matchForms": [
              {
                "text": "辛苦",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "辛苦",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.i4": {
            "cardId": "office-life.a.i4",
            "displayText": "阶级",
            "matchForms": [
              {
                "text": "阶级",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "阶级",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.q1": {
            "cardId": "office-life.a.q1",
            "displayText": "政治",
            "matchForms": [
              {
                "text": "政治",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "政治",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.q2": {
            "cardId": "office-life.a.q2",
            "displayText": "压力",
            "matchForms": [
              {
                "text": "压力",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "压力",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.q3": {
            "cardId": "office-life.a.q3",
            "displayText": "升职",
            "matchForms": [
              {
                "text": "升职",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "升职",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.q4": {
            "cardId": "office-life.a.q4",
            "displayText": "指标",
            "matchForms": [
              {
                "text": "指标",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "指标",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.a.q5": {
            "cardId": "office-life.a.q5",
            "displayText": "收到",
            "matchForms": [
              {
                "text": "收到",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "收到",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.i1": {
            "cardId": "office-life.b.i1",
            "displayText": "汇报",
            "matchForms": [
              {
                "text": "汇报",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "汇报",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.i2": {
            "cardId": "office-life.b.i2",
            "displayText": "军事",
            "matchForms": [
              {
                "text": "军事",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "军事",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.i3": {
            "cardId": "office-life.b.i3",
            "displayText": "救命",
            "matchForms": [
              {
                "text": "救命",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "救命",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.i4": {
            "cardId": "office-life.b.i4",
            "displayText": "八卦",
            "matchForms": [
              {
                "text": "八卦",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "八卦",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.q1": {
            "cardId": "office-life.b.q1",
            "displayText": "退休",
            "matchForms": [
              {
                "text": "退休",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "退休",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.q2": {
            "cardId": "office-life.b.q2",
            "displayText": "工资",
            "matchForms": [
              {
                "text": "工资",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "工资",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.q3": {
            "cardId": "office-life.b.q3",
            "displayText": "服务器",
            "matchForms": [
              {
                "text": "服务器",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "服务器",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.q4": {
            "cardId": "office-life.b.q4",
            "displayText": "加班",
            "matchForms": [
              {
                "text": "加班",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "加班",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.b.q5": {
            "cardId": "office-life.b.q5",
            "displayText": "发际线",
            "matchForms": [
              {
                "text": "发际线",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "发际线",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.i1": {
            "cardId": "office-life.c.i1",
            "displayText": "面试",
            "matchForms": [
              {
                "text": "面试",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "面试",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.i2": {
            "cardId": "office-life.c.i2",
            "displayText": "五险",
            "matchForms": [
              {
                "text": "五险",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "五险",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.i3": {
            "cardId": "office-life.c.i3",
            "displayText": "对齐",
            "matchForms": [
              {
                "text": "对齐",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "对齐",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.i4": {
            "cardId": "office-life.c.i4",
            "displayText": "面子",
            "matchForms": [
              {
                "text": "面子",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "面子",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.q1": {
            "cardId": "office-life.c.q1",
            "displayText": "外卖",
            "matchForms": [
              {
                "text": "外卖",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "外卖",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.q2": {
            "cardId": "office-life.c.q2",
            "displayText": "培训",
            "matchForms": [
              {
                "text": "培训",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "培训",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.q3": {
            "cardId": "office-life.c.q3",
            "displayText": "负责",
            "matchForms": [
              {
                "text": "负责",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "负责",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.q4": {
            "cardId": "office-life.c.q4",
            "displayText": "方案",
            "matchForms": [
              {
                "text": "方案",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "方案",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.c.q5": {
            "cardId": "office-life.c.q5",
            "displayText": "拒绝",
            "matchForms": [
              {
                "text": "拒绝",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "拒绝",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.i1": {
            "cardId": "office-life.d.i1",
            "displayText": "同事",
            "matchForms": [
              {
                "text": "同事",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "同事",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.i2": {
            "cardId": "office-life.d.i2",
            "displayText": "逃避",
            "matchForms": [
              {
                "text": "逃避",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "逃避",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.i3": {
            "cardId": "office-life.d.i3",
            "displayText": "远方",
            "matchForms": [
              {
                "text": "远方",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "远方",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.i4": {
            "cardId": "office-life.d.i4",
            "displayText": "熬夜",
            "matchForms": [
              {
                "text": "熬夜",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "熬夜",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.q1": {
            "cardId": "office-life.d.q1",
            "displayText": "巅峰",
            "matchForms": [
              {
                "text": "巅峰",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "巅峰",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.q2": {
            "cardId": "office-life.d.q2",
            "displayText": "星座",
            "matchForms": [
              {
                "text": "星座",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "星座",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.q3": {
            "cardId": "office-life.d.q3",
            "displayText": "误会",
            "matchForms": [
              {
                "text": "误会",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "误会",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.q4": {
            "cardId": "office-life.d.q4",
            "displayText": "一把手",
            "matchForms": [
              {
                "text": "一把手",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "一把手",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.d.q5": {
            "cardId": "office-life.d.q5",
            "displayText": "摸鱼",
            "matchForms": [
              {
                "text": "摸鱼",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "摸鱼",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.i1": {
            "cardId": "office-life.e.i1",
            "displayText": "出差",
            "matchForms": [
              {
                "text": "出差",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "出差",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.i2": {
            "cardId": "office-life.e.i2",
            "displayText": "权限",
            "matchForms": [
              {
                "text": "权限",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "权限",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.i3": {
            "cardId": "office-life.e.i3",
            "displayText": "没问题",
            "matchForms": [
              {
                "text": "没问题",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "没问题",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.i4": {
            "cardId": "office-life.e.i4",
            "displayText": "道歉",
            "matchForms": [
              {
                "text": "道歉",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "道歉",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.q1": {
            "cardId": "office-life.e.q1",
            "displayText": "情商",
            "matchForms": [
              {
                "text": "情商",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "情商",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.q2": {
            "cardId": "office-life.e.q2",
            "displayText": "年假",
            "matchForms": [
              {
                "text": "年假",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "年假",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.q3": {
            "cardId": "office-life.e.q3",
            "displayText": "沉默",
            "matchForms": [
              {
                "text": "沉默",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "沉默",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.q4": {
            "cardId": "office-life.e.q4",
            "displayText": "鸡犬升天",
            "matchForms": [
              {
                "text": "鸡犬升天",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "鸡犬升天",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.e.q5": {
            "cardId": "office-life.e.q5",
            "displayText": "画饼",
            "matchForms": [
              {
                "text": "画饼",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "画饼",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.r.1": {
            "cardId": "office-life.r.1",
            "displayText": "甩锅",
            "matchForms": [
              {
                "text": "甩锅",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "甩锅",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.r.2": {
            "cardId": "office-life.r.2",
            "displayText": "赚钱",
            "matchForms": [
              {
                "text": "赚钱",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "赚钱",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.r.3": {
            "cardId": "office-life.r.3",
            "displayText": "客户",
            "matchForms": [
              {
                "text": "客户",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "客户",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.r.4": {
            "cardId": "office-life.r.4",
            "displayText": "表格",
            "matchForms": [
              {
                "text": "表格",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "表格",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "office-life.r.5": {
            "cardId": "office-life.r.5",
            "displayText": "副业",
            "matchForms": [
              {
                "text": "副业",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "副业",
              "en": "__TODO_TRANSLATION__"
            }
          }
        },
        "packets": [
          {
            "packetId": "office-life.packet-a",
            "initial": [
              "office-life.a.i1",
              "office-life.a.i2",
              "office-life.a.i3",
              "office-life.a.i4"
            ],
            "penalty": [
              "office-life.a.q1",
              "office-life.a.q2",
              "office-life.a.q3",
              "office-life.a.q4",
              "office-life.a.q5"
            ]
          },
          {
            "packetId": "office-life.packet-b",
            "initial": [
              "office-life.b.i1",
              "office-life.b.i2",
              "office-life.b.i3",
              "office-life.b.i4"
            ],
            "penalty": [
              "office-life.b.q1",
              "office-life.b.q2",
              "office-life.b.q3",
              "office-life.b.q4",
              "office-life.b.q5"
            ]
          },
          {
            "packetId": "office-life.packet-c",
            "initial": [
              "office-life.c.i1",
              "office-life.c.i2",
              "office-life.c.i3",
              "office-life.c.i4"
            ],
            "penalty": [
              "office-life.c.q1",
              "office-life.c.q2",
              "office-life.c.q3",
              "office-life.c.q4",
              "office-life.c.q5"
            ]
          },
          {
            "packetId": "office-life.packet-d",
            "initial": [
              "office-life.d.i1",
              "office-life.d.i2",
              "office-life.d.i3",
              "office-life.d.i4"
            ],
            "penalty": [
              "office-life.d.q1",
              "office-life.d.q2",
              "office-life.d.q3",
              "office-life.d.q4",
              "office-life.d.q5"
            ]
          },
          {
            "packetId": "office-life.packet-e",
            "initial": [
              "office-life.e.i1",
              "office-life.e.i2",
              "office-life.e.i3",
              "office-life.e.i4"
            ],
            "penalty": [
              "office-life.e.q1",
              "office-life.e.q2",
              "office-life.e.q3",
              "office-life.e.q4",
              "office-life.e.q5"
            ]
          }
        ],
        "reserves": [
          "office-life.r.1",
          "office-life.r.2",
          "office-life.r.3",
          "office-life.r.4",
          "office-life.r.5"
        ],
        "allowedLineups": {
          "3": [
            {
              "lineupId": "office-life.lineup-3-ace",
              "packetIds": [
                "office-life.packet-a",
                "office-life.packet-c",
                "office-life.packet-e"
              ]
            }
          ],
          "4": [
            {
              "lineupId": "office-life.lineup-4-abde",
              "packetIds": [
                "office-life.packet-a",
                "office-life.packet-b",
                "office-life.packet-d",
                "office-life.packet-e"
              ]
            }
          ],
          "5": [
            {
              "lineupId": "office-life.lineup-5-abcde",
              "packetIds": [
                "office-life.packet-a",
                "office-life.packet-b",
                "office-life.packet-c",
                "office-life.packet-d",
                "office-life.packet-e"
              ]
            }
          ]
        }
      }
    },
    {
      "key": "pet-companions",
      "sourceName": "pet-companions.md",
      "outputName": "pet-companions.candidate.v1.json",
      "catalogRevision": "catalog.pet-companions.candidate-1",
      "theme": {
        "themeId": "theme.pet-companions",
        "themeRevision": "rev.candidate-1",
        "compatibleRulesVersion": "rules-v0.3",
        "compatibleDealVersion": "deal-v1",
        "compatibleMatcherVersion": "matcher-v1",
        "supportedPlayerCounts": [
          3,
          4,
          5
        ],
        "candidateStatus": {
          "stage": "MARKDOWN_SOURCE_CANDIDATE",
          "humanPlaytested": false,
          "approvedForProduction": false,
          "notice": {
            "zh": "候选内容，尚未经过真人桌测，不得视为已平衡或可正式发布。",
            "en": "__TODO_TRANSLATION__"
          }
        },
        "title": {
          "zh": "宠物伙伴",
          "en": "__TODO_TRANSLATION__"
        },
        "scenario": {
          "zh": "聊聊你养的宠物吧！",
          "en": "__TODO_TRANSLATION__"
        },
        "icebreakers": [
          {
            "icebreakerId": "pet-companions.icebreaker-1",
            "zh": "想养什么宠物？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "pet-companions.icebreaker-2",
            "zh": "见过的最有个性的宠物？",
            "en": "__TODO_TRANSLATION__"
          },
          {
            "icebreakerId": "pet-companions.icebreaker-3",
            "zh": "养宠物最烦的事？",
            "en": "__TODO_TRANSLATION__"
          }
        ],
        "cards": {
          "pet-companions.a.i1": {
            "cardId": "pet-companions.a.i1",
            "displayText": "多少钱",
            "matchForms": [
              {
                "text": "多少钱",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "多少钱",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.i2": {
            "cardId": "pet-companions.a.i2",
            "displayText": "寄养",
            "matchForms": [
              {
                "text": "寄养",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "寄养",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.i3": {
            "cardId": "pet-companions.a.i3",
            "displayText": "不管",
            "matchForms": [
              {
                "text": "不管",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "不管",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.i4": {
            "cardId": "pet-companions.a.i4",
            "displayText": "家人",
            "matchForms": [
              {
                "text": "家人",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "家人",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.q1": {
            "cardId": "pet-companions.a.q1",
            "displayText": "牙齿",
            "matchForms": [
              {
                "text": "牙齿",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "牙齿",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.q2": {
            "cardId": "pet-companions.a.q2",
            "displayText": "疫苗",
            "matchForms": [
              {
                "text": "疫苗",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "疫苗",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.q3": {
            "cardId": "pet-companions.a.q3",
            "displayText": "拆家",
            "matchForms": [
              {
                "text": "拆家",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "拆家",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.q4": {
            "cardId": "pet-companions.a.q4",
            "displayText": "AI",
            "matchForms": [
              {
                "text": "AI",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "AI",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.a.q5": {
            "cardId": "pet-companions.a.q5",
            "displayText": "乖乖",
            "matchForms": [
              {
                "text": "乖乖",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "乖乖",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.i1": {
            "cardId": "pet-companions.b.i1",
            "displayText": "生病",
            "matchForms": [
              {
                "text": "生病",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "生病",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.i2": {
            "cardId": "pet-companions.b.i2",
            "displayText": "乌龟",
            "matchForms": [
              {
                "text": "乌龟",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "乌龟",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.i3": {
            "cardId": "pet-companions.b.i3",
            "displayText": "宝宝",
            "matchForms": [
              {
                "text": "宝宝",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "宝宝",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.i4": {
            "cardId": "pet-companions.b.i4",
            "displayText": "扫地",
            "matchForms": [
              {
                "text": "扫地",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "扫地",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.q1": {
            "cardId": "pet-companions.b.q1",
            "displayText": "蜥蜴",
            "matchForms": [
              {
                "text": "蜥蜴",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "蜥蜴",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.q2": {
            "cardId": "pet-companions.b.q2",
            "displayText": "洗澡",
            "matchForms": [
              {
                "text": "洗澡",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "洗澡",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.q3": {
            "cardId": "pet-companions.b.q3",
            "displayText": "纸箱",
            "matchForms": [
              {
                "text": "纸箱",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "纸箱",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.q4": {
            "cardId": "pet-companions.b.q4",
            "displayText": "下雨",
            "matchForms": [
              {
                "text": "下雨",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "下雨",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.b.q5": {
            "cardId": "pet-companions.b.q5",
            "displayText": "听话",
            "matchForms": [
              {
                "text": "听话",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "听话",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.i1": {
            "cardId": "pet-companions.c.i1",
            "displayText": "牵着",
            "matchForms": [
              {
                "text": "牵着",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "牵着",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.i2": {
            "cardId": "pet-companions.c.i2",
            "displayText": "爪子",
            "matchForms": [
              {
                "text": "爪子",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "爪子",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.i3": {
            "cardId": "pet-companions.c.i3",
            "displayText": "毛茸茸",
            "matchForms": [
              {
                "text": "毛茸茸",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "毛茸茸",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.i4": {
            "cardId": "pet-companions.c.i4",
            "displayText": "进化",
            "matchForms": [
              {
                "text": "进化",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "进化",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.q1": {
            "cardId": "pet-companions.c.q1",
            "displayText": "走丢",
            "matchForms": [
              {
                "text": "走丢",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "走丢",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.q2": {
            "cardId": "pet-companions.c.q2",
            "displayText": "玩具",
            "matchForms": [
              {
                "text": "玩具",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "玩具",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.q3": {
            "cardId": "pet-companions.c.q3",
            "displayText": "铲屎",
            "matchForms": [
              {
                "text": "铲屎",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "铲屎",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.q4": {
            "cardId": "pet-companions.c.q4",
            "displayText": "摸头",
            "matchForms": [
              {
                "text": "摸头",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "摸头",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.c.q5": {
            "cardId": "pet-companions.c.q5",
            "displayText": "喂食",
            "matchForms": [
              {
                "text": "喂食",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "喂食",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.i1": {
            "cardId": "pet-companions.d.i1",
            "displayText": "拍照",
            "matchForms": [
              {
                "text": "拍照",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "拍照",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.i2": {
            "cardId": "pet-companions.d.i2",
            "displayText": "尾巴",
            "matchForms": [
              {
                "text": "尾巴",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "尾巴",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.i3": {
            "cardId": "pet-companions.d.i3",
            "displayText": "天敌",
            "matchForms": [
              {
                "text": "天敌",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "天敌",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.i4": {
            "cardId": "pet-companions.d.i4",
            "displayText": "责任",
            "matchForms": [
              {
                "text": "责任",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "责任",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.q1": {
            "cardId": "pet-companions.d.q1",
            "displayText": "绝育",
            "matchForms": [
              {
                "text": "绝育",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "绝育",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.q2": {
            "cardId": "pet-companions.d.q2",
            "displayText": "旅行",
            "matchForms": [
              {
                "text": "旅行",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "旅行",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.q3": {
            "cardId": "pet-companions.d.q3",
            "displayText": "兔子",
            "matchForms": [
              {
                "text": "兔子",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "兔子",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.q4": {
            "cardId": "pet-companions.d.q4",
            "displayText": "应激",
            "matchForms": [
              {
                "text": "应激",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "应激",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.d.q5": {
            "cardId": "pet-companions.d.q5",
            "displayText": "零食",
            "matchForms": [
              {
                "text": "零食",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "零食",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.i1": {
            "cardId": "pet-companions.e.i1",
            "displayText": "装死",
            "matchForms": [
              {
                "text": "装死",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "装死",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.i2": {
            "cardId": "pet-companions.e.i2",
            "displayText": "鹦鹉",
            "matchForms": [
              {
                "text": "鹦鹉",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "鹦鹉",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.i3": {
            "cardId": "pet-companions.e.i3",
            "displayText": "打滚",
            "matchForms": [
              {
                "text": "打滚",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "DUAL",
            "localization": {
              "zh": "打滚",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.i4": {
            "cardId": "pet-companions.e.i4",
            "displayText": "祖宗",
            "matchForms": [
              {
                "text": "祖宗",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "祖宗",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.q1": {
            "cardId": "pet-companions.e.q1",
            "displayText": "罐头",
            "matchForms": [
              {
                "text": "罐头",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "罐头",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.q2": {
            "cardId": "pet-companions.e.q2",
            "displayText": "血统",
            "matchForms": [
              {
                "text": "血统",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "血统",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.q3": {
            "cardId": "pet-companions.e.q3",
            "displayText": "公园",
            "matchForms": [
              {
                "text": "公园",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "公园",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.q4": {
            "cardId": "pet-companions.e.q4",
            "displayText": "流浪",
            "matchForms": [
              {
                "text": "流浪",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "流浪",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.e.q5": {
            "cardId": "pet-companions.e.q5",
            "displayText": "安乐死",
            "matchForms": [
              {
                "text": "安乐死",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "安乐死",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.r.1": {
            "cardId": "pet-companions.r.1",
            "displayText": "可爱",
            "matchForms": [
              {
                "text": "可爱",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "可爱",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.r.2": {
            "cardId": "pet-companions.r.2",
            "displayText": "笼子",
            "matchForms": [
              {
                "text": "笼子",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "笼子",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.r.3": {
            "cardId": "pet-companions.r.3",
            "displayText": "尊严",
            "matchForms": [
              {
                "text": "尊严",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "尊严",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.r.4": {
            "cardId": "pet-companions.r.4",
            "displayText": "保险",
            "matchForms": [
              {
                "text": "保险",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "保险",
              "en": "__TODO_TRANSLATION__"
            }
          },
          "pet-companions.r.5": {
            "cardId": "pet-companions.r.5",
            "displayText": "品种",
            "matchForms": [
              {
                "text": "品种",
                "mode": "SUBSTRING"
              }
            ],
            "cardKind": "NORMAL",
            "localization": {
              "zh": "品种",
              "en": "__TODO_TRANSLATION__"
            }
          }
        },
        "packets": [
          {
            "packetId": "pet-companions.packet-a",
            "initial": [
              "pet-companions.a.i1",
              "pet-companions.a.i2",
              "pet-companions.a.i3",
              "pet-companions.a.i4"
            ],
            "penalty": [
              "pet-companions.a.q1",
              "pet-companions.a.q2",
              "pet-companions.a.q3",
              "pet-companions.a.q4",
              "pet-companions.a.q5"
            ]
          },
          {
            "packetId": "pet-companions.packet-b",
            "initial": [
              "pet-companions.b.i1",
              "pet-companions.b.i2",
              "pet-companions.b.i3",
              "pet-companions.b.i4"
            ],
            "penalty": [
              "pet-companions.b.q1",
              "pet-companions.b.q2",
              "pet-companions.b.q3",
              "pet-companions.b.q4",
              "pet-companions.b.q5"
            ]
          },
          {
            "packetId": "pet-companions.packet-c",
            "initial": [
              "pet-companions.c.i1",
              "pet-companions.c.i2",
              "pet-companions.c.i3",
              "pet-companions.c.i4"
            ],
            "penalty": [
              "pet-companions.c.q1",
              "pet-companions.c.q2",
              "pet-companions.c.q3",
              "pet-companions.c.q4",
              "pet-companions.c.q5"
            ]
          },
          {
            "packetId": "pet-companions.packet-d",
            "initial": [
              "pet-companions.d.i1",
              "pet-companions.d.i2",
              "pet-companions.d.i3",
              "pet-companions.d.i4"
            ],
            "penalty": [
              "pet-companions.d.q1",
              "pet-companions.d.q2",
              "pet-companions.d.q3",
              "pet-companions.d.q4",
              "pet-companions.d.q5"
            ]
          },
          {
            "packetId": "pet-companions.packet-e",
            "initial": [
              "pet-companions.e.i1",
              "pet-companions.e.i2",
              "pet-companions.e.i3",
              "pet-companions.e.i4"
            ],
            "penalty": [
              "pet-companions.e.q1",
              "pet-companions.e.q2",
              "pet-companions.e.q3",
              "pet-companions.e.q4",
              "pet-companions.e.q5"
            ]
          }
        ],
        "reserves": [
          "pet-companions.r.1",
          "pet-companions.r.2",
          "pet-companions.r.3",
          "pet-companions.r.4",
          "pet-companions.r.5"
        ],
        "allowedLineups": {
          "3": [
            {
              "lineupId": "pet-companions.lineup-3-ace",
              "packetIds": [
                "pet-companions.packet-a",
                "pet-companions.packet-c",
                "pet-companions.packet-e"
              ]
            }
          ],
          "4": [
            {
              "lineupId": "pet-companions.lineup-4-abde",
              "packetIds": [
                "pet-companions.packet-a",
                "pet-companions.packet-b",
                "pet-companions.packet-d",
                "pet-companions.packet-e"
              ]
            }
          ],
          "5": [
            {
              "lineupId": "pet-companions.lineup-5-abcde",
              "packetIds": [
                "pet-companions.packet-a",
                "pet-companions.packet-b",
                "pet-companions.packet-c",
                "pet-companions.packet-d",
                "pet-companions.packet-e"
              ]
            }
          ]
        }
      }
    }
  ]
}
